import httpClient from './httpClient';

export const VARIANT_INFO_ENDPOINT = '/backoffice/variant-infos';

export const getVariantInfoListAPI = (params = {}) => httpClient.get(VARIANT_INFO_ENDPOINT, { params });
export const getVariantInfoAPI = (id) => httpClient.get(`${VARIANT_INFO_ENDPOINT}/${id}`);
export const postVariantInfoAPI = (params) => httpClient.post(`${VARIANT_INFO_ENDPOINT}`, params);
export const updateVariantInfoAPI = (id, params) => httpClient.put(`${VARIANT_INFO_ENDPOINT}/${id}`, params);
export const deleteVariantInfoAPI = (id) => httpClient.delete(`${VARIANT_INFO_ENDPOINT}/${id}`);
